export const SEARCH_QUERY_URL_PARAM = 'query';

// Global Search Quick Results Section Titles
export const GLOBAL_SEARCH_SECTION_TITLES = {
  PROFILE: 'Found in profile',
  CAPTIONS: 'Found in captions',
  LIST_NAMES: 'Found in list names',
} as const;

// Global Search Tab Labels
export const GLOBAL_SEARCH_TAB_LABELS = {
  ALL: 'All results',
  PROFILE: 'Found in profile',
  CAPTIONS: 'Found in captions',
  LISTS: 'Found in list names',
  TTA: 'Talent talking about',
} as const;

// Global Search Collapsed Section Titles (for main search results)
export const GLOBAL_SEARCH_COLLAPSED_TITLES = {
  PROFILE: 'profile',
  CAPTIONS: 'captions',
  LIST_NAMES: 'list name',
  TTA: 'Talent talking about',
} as const;

// Global Search Filter Section Titles
export const GLOBAL_SEARCH_FILTER_TITLES = {
  BY_PLATFORM: 'By Platform',
  BY_TALENT: 'By Talent',
  BY_CONTENT: 'By Content',
  BY_AUDIENCE: 'By Audience',
  TALENT: 'Talent',
  CONTENT: 'Content',
} as const;

// Global Search Common Texts
export const GLOBAL_SEARCH_TEXTS = {
  FOUND_IN: 'Found in',
  SEE_ALL: 'See all',
  NO_RESULTS_FOUND: 'No results found',
  EDIT_SEARCH_TERMS: 'Edit search terms',
  EDIT_FILTERS: 'Edit filters',
  CLEAR_FILTERS: 'Clear filters',
  FILTERS: 'Filters',
} as const;
